module.exports = __webpack_public_path__ + "static/media/outline-add-24px.322a1147.svg";